import { roundFloatPointNum } from './number-helpers'

/**
 * Конвертация цены в базовую валюту (для которой курс равен 1)
 * @param {number|string} value - значение цены заданной валюты
 * @param {number|string} rate - курс заданной валюты
 * @returns {number} - значение цены в "базовой" валюте
 */
export const convertByRate = (value, rate) => {
  return roundFloatPointNum(value * rate)
}
